export const getAccountIdFromAri = (ari = ''): string => ari.split('/')[1] ?? ari;
